import './GraficosDashboard.css';

export const PerformanceChart = ({ data, formatCurrency }) => (
    <div className="metrics-card">
        <div className="metrics-card-header">
            <h3>Desempenho por Barbeiro</h3>
            <span className="metrics-period-label">Total Ganhos</span>
        </div>
        <div className="performance-chart">
            {data.map(barber => (
                <div key={barber.name} className="bar-row">
                    <span className="bar-label">{barber.name}</span>
                    <div className="bar-container">
                        <div className="bar-fill" style={{ width: `${barber.width}%` }}>
                            <div className="bar-glow"></div>
                        </div>
                    </div>
                    <span className="bar-value">{formatCurrency(barber.total)}</span>
                </div>
            ))}
        </div>
    </div>
);

export const OccupancyChart = ({ data }) => (
    <div className="metrics-card">
        <div className="metrics-card-header">
            <h3>Ocupação por Dia</h3>
            <span className="metrics-period-label">% Agendamentos</span>
        </div>
        <div className="occupancy-chart">
            {data.map(day => (
                <div key={day.day} className="v-bar-container">
                    <div className="v-bar-fill-wrapper">
                        <div className="v-bar-track"></div>
                        <div className="v-bar-fill" style={{ height: `${day.height}%` }}>
                            <span className="v-bar-tooltip">{day.count} agend.</span>
                            <div className="v-bar-glow"></div>
                        </div>
                    </div>
                    <span className="v-bar-label">{day.day}</span>
                </div>
            ))}
        </div>
    </div>
);

export const MonthlyRevenueChart = ({ data, formatCurrency }) => (
    <div className="metrics-card monthly-summary-card">
        <div className="metrics-card-header">
            <h3>Desempenho Mensal (R$)</h3>
            <span className="metrics-period-label">Últimos 3 Meses</span>
        </div>
        <div className="occupancy-chart"> {/* Reusing vertical layout class */}
            {data.map((item, index) => (
                <div key={index} className="v-bar-container">
                    <div className="v-bar-fill-wrapper">
                        <div className="v-bar-track"></div>
                        <div className="v-bar-fill" style={{ height: `${item.height}%` }}>
                            <span className="v-bar-tooltip">{formatCurrency(item.revenue)}</span>
                            <div className="v-bar-glow"></div>
                        </div>
                    </div>
                    {item.growth && (
                        <div className={`growth-badge ${(item.growth.includes('↑') || item.growth.includes('+')) ? 'positive' : 'negative'}`}>
                            {item.growth}
                        </div>
                    )}
                    <span className="v-bar-label">{item.month}</span>
                </div>
            ))}
        </div>
    </div >
);
